module.exports = __webpack_public_path__ + "static/img/printing PU Processing3.eec3a40d.jpg";